"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAndSortData = exports.performSorting = exports.calculateColumnSizes = exports.getFilteredData = exports.headers = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
exports.headers = [
    'name',
    'projects',
    'employees',
    'federated',
    'reliablePartnerCompanyName'
];
var getFilteredData = function (list, searchString, filters) {
    if (searchString === void 0) { searchString = ''; }
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (searchString.length > 0) {
            return list.filter(function (item) {
                return item.name.toLowerCase().includes(searchString.toLowerCase());
            });
        }
        return __spreadArray([], list, true);
    }
    var filtered = list.reduce(function (result, item) {
        var _a;
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var searchValue = filters[key];
            switch (key) {
                case 'federated': {
                    var value = (0, translation_1.getLocalization)(item[key] ? 'global/yes' : 'global/no');
                    if (searchValue &&
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                case 'projects':
                case 'employees': {
                    var value = "".concat(item[key] !== undefined ? item[key] : '-');
                    if (searchValue &&
                        value &&
                        value.indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                    break;
                }
                case 'reliablePartnerCompanyName': {
                    var value = ((_a = item.reliablePartnerCompanyName) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase()) || '-';
                    if (searchValue && !value.includes(searchValue.toLowerCase())) {
                        return result;
                    }
                    break;
                }
                default: {
                    var value = item[key];
                    if (searchValue &&
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return result;
                    }
                }
            }
        }
        if (item.name.toString().includes(searchString)) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
};
exports.getFilteredData = getFilteredData;
var calculateColumnSizes = function (items, mergedProps, setContentWidth) {
    var columns = items.reduce(function (acc, item) {
        Object.keys(item).forEach(function (customer) {
            if (mergedProps.isMobile) {
                if (customer === 'id' || customer !== 'name') {
                    return;
                }
            }
            else {
                if (!exports.headers.includes(customer)) {
                    return;
                }
            }
            var dataKey = '__' + customer.replace(/-/g, '');
            var text = (function (reliablePartnerSettings, customer) {
                if (customer === 'projects' ||
                    customer === 'employees' ||
                    customer === 'federated' ||
                    customer === 'reliablePartnerCompanyName') {
                    return reliablePartnerSettings.toString();
                }
                return reliablePartnerSettings;
            })((item[customer] || '').toString(), customer);
            var length = (0, text_1.calculateStringLength)(text);
            var prevValue = acc[dataKey];
            if (!prevValue || (prevValue && prevValue < length)) {
                acc[dataKey] = length;
            }
        });
        return acc;
    }, {});
    exports.headers.forEach(function (header) {
        var dataKey = '__' + header.replace(/-/g, '');
        var text = (0, translation_1.getLocalization)("managementView/column/".concat(header)).toString();
        var length = (0, text_1.calculateStringLength)(text) + 42;
        var prevValue = columns[dataKey];
        if (prevValue && prevValue < length) {
            columns[dataKey] = length;
        }
        else if (!prevValue) {
            columns[dataKey] = length;
        }
    });
    var lengths = Object.keys(columns).reduce(function (prev, x) {
        prev[x] = columns[x];
        return prev;
    }, {});
    // Override styles for dynamic classes
    var style = document.getElementById('ManagementListCSS');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'ManagementListCSS';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    setContentWidth(function (prevContentWidth) { return prevContentWidth + 42; });
    Object.keys(lengths).forEach(function (className, i) {
        var colWidth = Math.max(8, 4 + lengths[className] + 26);
        setContentWidth(function (prevContentWidth) { return prevContentWidth + colWidth; });
        sheet.insertRule(".".concat(className) +
            ' {max-width: ' +
            colWidth +
            'px;\n min-width: ' +
            colWidth +
            'px;}', i);
    });
};
exports.calculateColumnSizes = calculateColumnSizes;
var performSorting = function (orderBy, a, b, orderMultiplier) {
    switch (orderBy) {
        case 'name':
            return a[orderBy].localeCompare(b[orderBy]) * orderMultiplier;
        case 'reliablePartnerCompanyName':
            return ((a[orderBy] || '-').localeCompare(b[orderBy] || '-') * orderMultiplier);
        case 'projects':
        case 'employees':
            return ((a[orderBy] || 0) - (b[orderBy] || 0)) * orderMultiplier;
        case 'federated':
            var av = (0, translation_1.getLocalization)(a.federated ? 'global/yes' : 'global/no');
            var bv = (0, translation_1.getLocalization)(b.federated ? 'global/yes' : 'global/no');
            return av.localeCompare(bv) * orderMultiplier;
        default:
            return 0;
    }
};
exports.performSorting = performSorting;
var filterAndSortData = function (setTotal, setItems, mergedProps) {
    var _a = mergedProps.queryParams, order = _a.order, orderBy = _a.orderBy, search = _a.search, filters = __rest(_a, ["order", "orderBy", "search"]);
    var orderMultiplier = order === 'asc' ? 1 : -1;
    var list = mergedProps.list;
    var data = (0, exports.getFilteredData)(list.list, search, filters).sort(function (a, b) {
        return (0, exports.performSorting)(orderBy, a, b, orderMultiplier);
    });
    setTotal(data.length);
    setItems(data);
};
exports.filterAndSortData = filterAndSortData;
